export const GUIDE_RECOVERY_DISABLE_STORAGE_KEY = 'getdemo_guideRecoveryDisable';

export const isGuideRecoveryDisabled = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    const param = params.get('guideRecoveryDisable');
    if (param === 'true') {
      localStorage.setItem(GUIDE_RECOVERY_DISABLE_STORAGE_KEY, 'true');
      return true;
    }
    if (param === 'false') {
      localStorage.removeItem(GUIDE_RECOVERY_DISABLE_STORAGE_KEY);
      return false;
    }
    return localStorage.getItem(GUIDE_RECOVERY_DISABLE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};
